// @flow

import React, { type Node } from 'react';
import { Button } from '../../../commons/atoms';
import { theme } from '../../theme';
import { useCopyToClipboard } from './use-copy';

type Props = {
  copiedMessage: Node,
  copyMessage: Node,
  value: string,
};

export function CopyToClipboardButton({ copyMessage, copiedMessage, value }: Props): Node {

  const [Clipboard, copied, handleClick] = useCopyToClipboard();

  return (
    <Button
      as={Clipboard}
      onClick={handleClick}
      data-clipboard-text={value}
      copied={copied}
      background={copied ? theme.colors.green(50) : theme.colors.gray(0)}
      block
      height="68px"
    >
      {copied ? copiedMessage : copyMessage}
    </Button>
  );
}
